import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  const handleScroll = () => {
    setVisible(window.scrollY > 200);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    handleScroll(); // 初期判定
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!visible) return null;

  const btn = (
    <button
      onClick={scrollToTop}
      style={{
        position: "fixed",
        bottom: "32px",
        right: "32px",
        width: "72px",
        height: "72px",
        borderRadius: "50%",
        backgroundColor: "rgba(99, 123, 255, 0.85)",
        color: "#fff",
        border: "none",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        opacity: 1,
        transform: "translateY(0)",
        transition: "opacity 0.4s ease, transform 0.4s ease",
        zIndex: 9999,
        fontFamily: "sans-serif",
      }}
      onMouseEnter={(e) =>
        (e.currentTarget.style.backgroundColor = "rgba(99,123,255,1)")
      }
      onMouseLeave={(e) =>
        (e.currentTarget.style.backgroundColor = "rgba(99,123,255,0.85)")
      }
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        viewBox="0 0 24 24"
      >
        <polyline points="6 15 12 9 18 15" />
      </svg>
      <div style={{ fontSize: "12px", fontWeight: "bold", marginTop: "2px" }}>
        TOP
      </div>
    </button>
  );

  // ★ ここがポイント：常に body 直下へ描画（transform の影響を受けない）
  return createPortal(btn, document.body);
};

export default ScrollToTopButton;